import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import AppBarInner from '../components/app-bar/AppBarInner'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import SiteForm from '../components/app-form/SiteForm'
import CustomizeAll from '../components/сustomize-all/'
import { withSnackbar } from 'notistack'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    marginLeft: 74,
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Добавьте сайт \nдля анализа',
    'Настройте \nGoogle Analytics \nдля отображения \nрасширенных \nотчетов',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class Site extends Component {
  state = {
    activeStep: 1,
    site: window.state.site,
    isFetching: false,
    isCard: window.state.cardTest,
  }

  redirect = (nextUrl, status) => {
    if (status === 'ok') {
      location.href = nextUrl
    }
  }
  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/wizard/site'

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const handleServerError = message => {
      this.setState({
        isFetching: false,
      })

      if (message.errors && message.status == 422) {
        this.setState({
          errors: message.errors,
        })
      } else {
        const error = `Произошла ошибка на сервере (${message.status}). 
        Попробуйте снова или обратитесь в поддержку.`

        this.props.enqueueSnackbar(error, {
          variant: 'error',
          preventDuplicate: true,
          autoHideDuration: 6000,
        })
      }
    }

    function handleResponse(response) {
      return response.json().then(json => {
        if (response.ok) {
          return json
        } else {
          let error = Object.assign({}, json, {
            status: response.status,
            statusText: response.statusText,
          })

          return Promise.reject(error)
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(({ nextUrl, status }) => {
        this.redirect(nextUrl, status)
      })
      .catch(message => handleServerError(message))
  }

  render() {
    const { classes } = this.props
    const { site, isCard } = this.state
    const steps = isCard ? getSteps() : getSteps().slice(0, -1)

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner />
        <CustomizeAll />

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard />

          <AppStepper activeStep={this.state.activeStep} steps={steps} />

          <div className={classes.wizardContent}>
            <Typography
              variant="body1"
              style={{
                fontFamily: 'Caveat, cursive',
                letterSpacing: 1.1,
                color: 'rgba(0, 0, 0, 0.6)',
                maxWidth: 300,
              }}
            >
              Укажите для какого ресурса ROMI center будет передавать данные о расходах из рекламных площадок, звонках из коллтрекинга, а также продаж из CRM системы.
            </Typography>
            <SiteForm
              onSubmit={this.handleSubmit}
              isFetching={this.state.isFetching}
              initialValues={site && { name: site.name, url: site.url }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(withSnackbar(Site))
